import { setError } from '../App/ErrorsActions';

import customFieldsUtils from '../../util/customFieldsUtils';
import CalculationsWorker from '../../services/worker';

let service, lastServiceId;
let pendingWipBreakdown = null;

export const ERROR = 'CTA_ERROR';
export const LOADING = 'CTA_LOADING';
export const SUCCESS = 'CTA_SUCCESS';
export const RESET = 'CTA_RESET';
export const ALL_LOADED = 'CTA_ALL_LOADED';
export const SUCCESS_WIP_BREAKDOWN = 'CTA_SUCCESS_WIP_BREAKDOWN';
export const LOADING_WIP_BREAKDOWN = 'CTA_LOADING_WIP_BREAKDOWN';

export function isLoading(bool) {
  return {
    type: LOADING,
    isLoading: bool
  };
}

export function success(data) {
  return {
    type: SUCCESS,
    data: data
  };
}

function successWipBreakdown(data) {
  return {
    type: SUCCESS_WIP_BREAKDOWN,
    data
  };
}

export function getData(enablePercentiles = true, getSingle = false) {
  return async (dispatch, getState) => {
    dispatch(isLoading(true));

    if (service) {
      service.terminate();
    }

    dispatch({
      type: RESET
    });
    pendingWipBreakdown = null;

    const { user } = getState().auth;
    const { selected } = getState().dashboards;
    const { data } = getState().app;

    const allFilters = getState().filters;
    const {
      chart,
      allCustomFields,
      excludeWeekends,
      workStart,
      workEnd,
      holidays,
      enabledColors,
      dates,
      cta
    } = allFilters;
    const filters = chart === 'overview' ? allFilters.overview : cta;

    const customFields = customFieldsUtils.getSelected(allCustomFields, filters);

    service = new CalculationsWorker();
    let worker = service.wrap();
    worker = await new worker(selected, data, enabledColors, {
      isCsv: selected.isCsv,
      enableDoneFilters: user.config.enableDoneFilters,
      enableMissingDoneActivitiesInserting: user.config.enableMissingDoneActivitiesInserting
    });

    try {
      const ctaData = await worker.CycleTimeAging({
        lists: filters.selectedLists,
        labels: filters.selectedLabels,
        members: filters.selectedMembers,
        customFields,
        excludeWeekendOpts: {
          type: excludeWeekends,
          workStart,
          workEnd,
          holidays
        },
        startDate: dates.startDate.toISOString(),
        endDate: dates.endDate.toISOString(),
        date: dates.singleDate.toISOString(),
        color: true,
        blockedTime: cta.blockedTime,
        blockers: cta.blockers,
        percentiles: enablePercentiles ? allFilters.allPercentileValues : undefined,
        healthZones: cta.selectedHealthZones,
        timeUnit: cta.timeUnit,
        breakdownBy: cta.breakdownBy,
        showColumns: cta.showColumns,
        getSingle,
        getBlockersStats: true,
        useWorkingHoursInCycleTimeDays: user.config && user.config.useWorkingHoursInCycleTimeDays
      });
     
      for await (const point of ctaData) {
        if (service.id != lastServiceId && +dates.endDate > +new Date(point.date)) {
          continue;
        }

        lastServiceId = service.id;
        dispatch(success(point));
      }

      dispatch({
        type: ALL_LOADED
      });
    } catch (err) {
      dispatch(setError(err));
    }
  };
}

export function getWipBreakdownData(ctaData, dayIndex, breakdownBy) {
  return async (dispatch, getState) => {
    const { wipBreakdownLoading } = getState().cta;
    if (wipBreakdownLoading) {
      pendingWipBreakdown = [ctaData, dayIndex, breakdownBy];
      return;
    }

    dispatch({ type: LOADING_WIP_BREAKDOWN, loading: true });

    try {
      const { selected } = getState().dashboards;
      const { data, app } = getState().app;

      const dataWithApp = { ...data, app: selected.application || app };

      const workerService = new CalculationsWorker();
      let worker = workerService.wrap();
      worker = await new worker(selected, dataWithApp);
      const breakdownData = await worker.GetWipBreakdownData(ctaData, dayIndex, breakdownBy);

      workerService.terminate();

      dispatch(successWipBreakdown(breakdownData));
    } catch (err) {
      dispatch(setError(err));
    } finally {
      dispatch({ type: LOADING_WIP_BREAKDOWN, loading: false });
      if (pendingWipBreakdown) {
        const next = pendingWipBreakdown;
        pendingWipBreakdown = null;
        dispatch(getWipBreakdownData(...next));
      }
    }
  };
}
